export const styles = theme => ({
    leftIcon: {
        marginRight: theme.spacing.unit
    },
    primaryIcon: {
        color: theme.palette.primary.main
    }
});
